export default 
{
    "resourceType": "Questionnaire",
    "id": "f7c2afe2-b98b-41b8-a66c-767e4f25b62b",
    "meta": {
        "versionId": "1",
        "lastUpdated": "2020-08-24T13:56:18.469+00:00"
    },
    "version": "1",
    "name": "DPCSTTQuestionnaire26/09",
    "title": "Digital Paediatric Cancer Survivorship Triage Tool",
    "status": "active",
    "subjectType": [
        "Patient"
    ],
    "date": "2020",
    "publisher": "Caitlin Lawrence",
    "description": "Triage tool questionnaire to risk stratify childhood cancer survivors",
    "purpose": "To risk stratify childhood cancer survivors",
    "item": [
        {
            "linkId": "A",
            "text": "Background Information",
            "type": "group",
            "item": [
                {
                    "linkId": "1",
                    "text": "Name",
                    "type": "string"
                },
                {
                    "linkId": "2",
                    "text": "MRN",
                    "type": "integer"
                },
                {
                    "linkId": "3",
                    "text": "Date of Birth",
                    "type": "date"
                },
                {
                    "linkId": "4",
                    "text": "Gender",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Male"
                        },
                        {
                            "id": "2",
                            "valueString": "Female"
                        },
                        {
                            "id": "3",
                            "valueString": "Other"
                        }
                    ]
                },
                {
                    "linkId": "5",
                    "text": "Current age",
                    "type": "integer"
                },
                {
                    "linkId": "6",
                    "text": "Age of diagnosis",
                    "type": "string"
                },
                {
                    "linkId": "7",
                    "text": "Primary diagnosis",
                    "type": "string"
                },
                {
                    "linkId": "8",
                    "text": "Level of risk",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Standard"
                        },
                        {
                            "id": "2",
                            "valueString": "Low"
                        },
                        {
                            "id": "3",
                            "valueString": "Intermediate"
                        },
                        {
                            "id": "4",
                            "valueString": "High"
                        },
                        {
                            "id": "5",
                            "valueString": "Don't know"
                        }
                    ]
                },
                {
                    "linkId": "9",
                    "text": "Oncologist",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Richard Cohn"
                        },
                        {
                            "id": "2",
                            "valueString": "Darcy O'Gormon-Hughes"
                        },
                        {
                            "id": "3",
                            "valueString": "Marcus Vowels"
                        },
                        {
                            "id": "4",
                            "valueString": "Glenn Marshall"
                        },
                        {
                            "id": "5",
                            "valueString": "Tracey O'Brien"
                        },
                        {
                            "id": "6",
                            "valueString": "Antoinette Anazodo"
                        },
                        {
                            "id": "7",
                            "valueString": "Draga Barbaric"
                        },
                        {
                            "id": "8",
                            "valueString": "Susan Russell"
                        },
                        {
                            "id": "9",
                            "valueString": "Toby Trahair"
                        },
                        {
                            "id": "10",
                            "valueString": "David Ziegler"
                        }
                    ]
                },
                {
                    "linkId": "10",
                    "text": "Age of parents",
                    "type": "string"
                },
                {
                    "linkId": "11",
                    "text": "Name of treating hospital",
                    "type": "string"
                },
                {
                    "linkId": "12",
                    "text": "Last seen by doctor",
                    "type": "string"
                },
                {
                    "linkId": "13",
                    "text": "Treatment",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Surgery"
                        },
                        {
                            "id": "2",
                            "valueString": "Chemotherapy"
                        },
                        {
                            "id": "3",
                            "valueString": "Radiotherapy"
                        },
                        {
                            "id": "4",
                            "valueString": "Bone Marrow Transplant/Stem Cell Transplant"
                        },
                        {
                            "id": "5",
                            "valueString": "Other"
                        }
                    ]
                },
                {
                    "linkId": "14",
                    "text": "Last follow-up appointment",
                    "type": "string"
                },
                {
                    "linkId": "15",
                    "text": "Years since active treatment",
                    "type": "integer"
                },
                {
                    "linkId": "16",
                    "text": "GP/Family Physician",
                    "type": "string"
                },
                {
                    "linkId": "17",
                    "text": "Employment status",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Full-time"
                        },
                        {
                            "id": "2",
                            "valueString": "Part-time"
                        },
                        {
                            "id": "3",
                            "valueString": "Casual"
                        },
                        {
                            "id": "4",
                            "valueString": "Actively seeking work"
                        },
                        {
                            "id": "5",
                            "valueString": "Not seeking work"
                        },
                        {
                            "id": "6",
                            "valueString": "Retired"
                        },
                        {
                            "id": "7",
                            "valueString": "Student"
                        },
                        {
                            "id": "8",
                            "valueString": "Home duties"
                        }
                    ]
                },
                {
                    "linkId": "18",
                    "text": "Level of Education",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Still in school"
                        },
                        {
                            "id": "2",
                            "valueString": "Year 10 or below"
                        },
                        {
                            "id": "3",
                            "valueString": "Year 12"
                        },
                        {
                            "id": "4",
                            "valueString": "Apprenticeship"
                        },
                        {
                            "id": "5",
                            "valueString": "Certificate/diploma"
                        },
                        {
                            "id": "6",
                            "valueString": "University degree"
                        },
                        {
                            "id": "7",
                            "valueString": "Post-graduate degree"
                        }
                    ]
                },
                {
                    "linkId": "19",
                    "text": "Job description",
                    "type": "string"
                },
                {
                    "linkId": "20",
                    "text": "Marital status",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Never married or never de facto"
                        },
                        {
                            "id": "2",
                            "valueString": "Currently married or de facto"
                        },
                        {
                            "id": "3",
                            "valueString": "Separated/divorced/previous de facto"
                        },
                        {
                            "id": "4",
                            "valueString": "Widowed"
                        }
                    ]
                },
                {
                    "linkId": "21",
                    "text": "Place of residence",
                    "type": "string"
                }
            ]
        },
        {
            "linkId": "B",
            "text": "Introduction",
            "type": "group",
            "item": [
                {
                    "linkId": "23",
                    "text": "How are you?",
                    "type": "string"
                },
                {
                    "linkId": "24",
                    "text": "What are you up to currently?",
                    "type": "string"
                },
                {
                    "linkId": "25",
                    "text": "How is your family?",
                    "type": "string"
                },
                {
                    "linkId": "26",
                    "text": "Are you living at home? Children?",
                    "type": "string"
                }
            ]
        },
        {
            "linkId": "C",
            "text": "Follow-Up",
            "type": "group",
            "item": [
                {
                    "linkId": "28",
                    "text": "Did your parents ever pass on information to you about your cancer or treatment?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "29",
                    "text": "Can you remember when you were you last seen at the hospital or long term follow-up clinic or by your oncologist?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "30",
                    "text": "Were you advised to return?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "31",
                    "text": "If yes why didn't you return?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "30",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "32",
                    "text": "If you are unsure, why didn't you return?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "30",
                            "answerCoding": {
                                "display": "Don't Know"
                            }
                        }
                    ]
                },
                {
                    "linkId": "33",
                    "text": "Have you received a treatment summary/passport etc?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "34",
                    "text": "If no would you like a summary?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "33",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "35",
                    "text": "How has your health been since we saw you last at the hospital?",
                    "type": "string"
                },
                {
                    "linkId": "36",
                    "text": "Have you been to the GP for any illnesses or concerns in the last 2 years?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "37",
                    "text": "If yes do you think any of these problems are related to your previous cancer diagnosis and/or treatment?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "36",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "38",
                    "text": "Are you seeing any other HCP for any health issues?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "39",
                    "text": "If yes do you think any of these problems are related to your previous cancer diagnosis and/or treatment?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "38",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "D",
            "text": "Medication and Supplements",
            "type": "group",
            "item": [
                {
                    "linkId": "41",
                    "text": "Are you on any regular medication?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "42",
                    "text": "If yes what medication, dosage, reason for use and date when started?",
                    "type": "text",
                    "enableWhen": [
                        {
                            "question": "41",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "43",
                    "text": "Are you taking any regular herbal supplements?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "44",
                    "text": "If yes what herbal supplements, dosage, reason for use and date when started?",
                    "type": "text",
                    "enableWhen": [
                        {
                            "question": "43",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "E",
            "text": "Recurrence",
            "type": "group",
            "item": [
                {
                    "linkId": "47",
                    "text": "Were you ever told that your cancer has returned?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "48",
                    "text": "If yes did you receive additional therapy?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "47",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "49",
                    "text": "Have you ever been diagnosed with a second cancer/ cancer that is different to the first one you had?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "50",
                    "text": "If yes did you receive additional therapy?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "49",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "F",
            "text": "Genetics",
            "type": "group",
            "item": [
                {
                    "linkId": "53",
                    "text": "Do you know what a genetic condition is? (if not, explain before proceeding)",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "54",
                    "text": "Are you aware of any genetic condition affecting you or your family?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "55",
                    "text": "If yes has anyone mentioned this may affect your risk of another cancer?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "54",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "56",
                    "text": "Do you have any relatives who were diagnosed with cancer under the age of 70 years?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "57",
                    "text": "If yes what was the cancer diagnosis, age of diagnosis and relation to you?",
                    "type": "text",
                    "enableWhen": [
                        {
                            "question": "56",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "G",
            "text": "Treatment",
            "type": "group",
            "item": [
                {
                    "linkId": "60",
                    "text": "Can you remember the names of any of the chemotherapy you received?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "2",
                            "valueString": "Don't Remember"
                        },
                        {
                            "id": "3",
                            "valueString": "Cisplatin"
                        },
                        {
                            "id": "4",
                            "valueString": "Carboplatin"
                        },
                        {
                            "id": "5",
                            "valueString": "Paclitaxel"
                        },
                        {
                            "id": "6",
                            "valueString": "Docetaxel"
                        },
                        {
                            "id": "7",
                            "valueString": "Cabazitaxel"
                        },
                        {
                            "id": "8",
                            "valueString": "Vincristine"
                        },
                        {
                            "id": "9",
                            "valueString": "Vinblastine"
                        },
                        {
                            "id": "10",
                            "valueString": "Venorelbine"
                        },
                        {
                            "id": "11",
                            "valueString": "Vinflunine"
                        },
                        {
                            "id": "12",
                            "valueString": "Vindesine"
                        },
                        {
                            "id": "13",
                            "valueString": "Thalidomide"
                        },
                        {
                            "id": "14",
                            "valueString": "Bortezamib"
                        },
                        {
                            "id": "15",
                            "valueString": "Ixabepilone"
                        },
                        {
                            "id": "16",
                            "valueString": "Lenalidomide Pomalidomide"
                        },
                        {
                            "id": "17",
                            "valueString": "Eribulin"
                        },
                        {
                            "id": "18",
                            "valueString": "Bleomycin"
                        },
                        {
                            "id": "19",
                            "valueString": "Etoposide"
                        },
                        {
                            "id": "20",
                            "valueString": "Anthracyclines"
                        },
                        {
                            "id": "21",
                            "valueString": "Oxaliplatin"
                        },
                        {
                            "id": "22",
                            "valueString": "Other"
                        }
                    ]
                },
                {
                    "linkId": "61",
                    "text": "Have you ever had a bone marrow/stem cell transplant?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "62",
                    "text": "If yes do you remember where your marrow came from?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "61",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "63",
                    "text": "If yes was it your own marrow or from a relative like a brother or sister a cord blood or from an anonymous unrelated donor?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "61",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Allogeneic"
                        },
                        {
                            "id": "2",
                            "valueString": "Autologous"
                        }
                    ]
                },
                {
                    "linkId": "64",
                    "text": "Have you had radiation treatment or radiotherapy?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "65",
                    "text": "If yes was it to one area of your body or to the whole body?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "64",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "66",
                    "text": "If yes do you know how old you were when you had your radiotherapy?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "64",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "67",
                    "text": "If yes have you ever received radiation to the head or brain?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "64",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "68",
                    "text": "Have you had surgery?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "69",
                    "text": "If yes what type of surgery?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "68",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "70",
                    "text": "If yes where did you have the surgery?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "68",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "H",
            "text": "Late Effects: Psychological",
            "type": "group",
            "item": [
                {
                    "linkId": "73",
                    "text": "Do you believe you have ever experienced any physical or emotional late complications from your cancer(s) or their treatment(s)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "74",
                    "text": "Since finishing treatment, do you think you have as much energy as your friends and family?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "75",
                    "text": "Do you need to take time off school or work because you are tired/fatigued?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "76",
                    "text": "If yes is it interfering with your normal activities, school /work?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "75",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "77",
                    "text": "Do you socialise with friends and family?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "78",
                    "text": "Do you smoke?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Never"
                        },
                        {
                            "id": "2",
                            "valueString": "Ex-smoker"
                        },
                        {
                            "id": "3",
                            "valueString": "Current smoker"
                        }
                    ]
                },
                {
                    "linkId": "79",
                    "text": "Do you take recreational drugs?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "No, never"
                        },
                        {
                            "id": "2",
                            "valueString": "Yes, used to"
                        },
                        {
                            "id": "3",
                            "valueString": "Yes, currently"
                        }
                    ]
                },
                {
                    "linkId": "80",
                    "text": "Do you regularly drink alcohol?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Never/given up alcohol"
                        },
                        {
                            "id": "2",
                            "valueString": "Only on special occasions"
                        },
                        {
                            "id": "3",
                            "valueString": "Regularly"
                        }
                    ]
                },
                {
                    "linkId": "81",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Anxiety"
                        },
                        {
                            "id": "2",
                            "valueString": "Problems accessing healthcare and/or insurance?"
                        },
                        {
                            "id": "3",
                            "valueString": "Access to NDIS?"
                        },
                        {
                            "id": "4",
                            "valueString": "Are you able to live independently?"
                        },
                        {
                            "id": "5",
                            "valueString": "Fatigue"
                        },
                        {
                            "id": "6",
                            "valueString": "Psychosocial disability due to pain arthritis related?"
                        },
                        {
                            "id": "7",
                            "valueString": "Behavioral problems, or changes in behaviour?"
                        },
                        {
                            "id": "8",
                            "valueString": "Problems at school or university?"
                        },
                        {
                            "id": "9",
                            "valueString": "Problems at work or finding work?"
                        },
                        {
                            "id": "10",
                            "valueString": "Problems in your relationship/marriage?"
                        },
                        {
                            "id": "11",
                            "valueString": "Suicidal ideation"
                        },
                        {
                            "id": "12",
                            "valueString": "Post-traumatic stress"
                        },
                        {
                            "id": "13",
                            "valueString": "Psychosocial disability due to pain"
                        },
                        {
                            "id": "14",
                            "valueString": "Social withdrawal"
                        },
                        {
                            "id": "15",
                            "valueString": "Social activities"
                        },
                        {
                            "id": "16",
                            "valueString": "Psychosocial maladjustment"
                        },
                        {
                            "id": "17",
                            "valueString": "Impaired quality of life"
                        },
                        {
                            "id": "18",
                            "valueString": "Other"
                        },
                        {
                            "id": "19",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "20",
                            "valueString": "Don't Remember"
                        }
                    ]
                },
                {
                    "linkId": "82",
                    "text": "If yes to any above, establish if this is currently an issue",
                    "type": "text"
                }
            ]
        },
        {
            "linkId": "I",
            "text": "Late Effects: Head and Neck",
            "type": "group",
            "item": [
                {
                    "linkId": "85",
                    "text": "Do you have any problems with your eyesight?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "86",
                    "text": "Do you wear glasses?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "87",
                    "text": "If yes do you know why?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "86",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Long-sighted"
                        },
                        {
                            "id": "2",
                            "valueString": "Short-sighted"
                        },
                        {
                            "id": "3",
                            "valueString": "Both"
                        }
                    ]
                },
                {
                    "linkId": "88",
                    "text": "Have you ever been told you have cataracts?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "89",
                    "text": "If yes have they ever caused you problems?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "88",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "90",
                    "text": "Do you have to use eye drops for dry eyes?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "91",
                    "text": "Do you have any other visual problems?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "92",
                    "text": "Has anyone ever told you that you have any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Visual impairment (uncorrectable)"
                        },
                        {
                            "id": "2",
                            "valueString": "Glaucoma"
                        },
                        {
                            "id": "3",
                            "valueString": "Lacrimal duct atrophy"
                        },
                        {
                            "id": "4",
                            "valueString": "Enophthalmos"
                        },
                        {
                            "id": "5",
                            "valueString": "Optic Chiasm neuropathy"
                        },
                        {
                            "id": "6",
                            "valueString": "Orbital hypoplasia"
                        },
                        {
                            "id": "7",
                            "valueString": "Keratitis"
                        },
                        {
                            "id": "8",
                            "valueString": "Xerophthalmia"
                        },
                        {
                            "id": "9",
                            "valueString": "Chronic painful eye"
                        },
                        {
                            "id": "10",
                            "valueString": "Ocular nerve palsy"
                        },
                        {
                            "id": "11",
                            "valueString": "Gaze paresis"
                        },
                        {
                            "id": "12",
                            "valueString": "Nystagmus"
                        },
                        {
                            "id": "13",
                            "valueString": "Papilledema"
                        },
                        {
                            "id": "14",
                            "valueString": "Optic atrophy"
                        },
                        {
                            "id": "15",
                            "valueString": "Other"
                        },
                        {
                            "id": "16",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "17",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "J",
            "text": "Late Effects: Auditory",
            "type": "group",
            "item": [
                {
                    "linkId": "95",
                    "text": "Do you have any trouble with your hearing?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "96",
                    "text": "Do you or have you every worn hearing aids?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "97",
                    "text": "Have you had your hearing tested?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "98",
                    "text": "If yes do you know why?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "97",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "99",
                    "text": "Do you suffer from tinnitus (ringing in the ears)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "100",
                    "text": "When did it start?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "99",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "101",
                    "text": "How much of a problem is it for you?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "99",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "102",
                    "text": "Do you see a HCP for it?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "99",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "103",
                    "text": "Do you have any problems with vertigo or balance (balance problems must be differentiated from cerebellar problems)",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "104",
                    "text": "Do you have any other problems related to your ears?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "105",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Ear infections"
                        },
                        {
                            "id": "2",
                            "valueString": "Eustachian tube dysfunction"
                        },
                        {
                            "id": "3",
                            "valueString": "Otosclerosis"
                        },
                        {
                            "id": "4",
                            "valueString": "Tympanosclerosis"
                        },
                        {
                            "id": "5",
                            "valueString": "Other"
                        },
                        {
                            "id": "6",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "7",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "K",
            "text": "Late Effects: Dental",
            "type": "group",
            "item": [
                {
                    "linkId": "108",
                    "text": "Do you see the dentist regularly?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "109",
                    "text": "If no when was the last time you saw them?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "108",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ]
                },
                {
                    "linkId": "110",
                    "text": "Do you see the same dentist?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "108",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "111",
                    "text": "Does the dentist have any concerns about your teeth?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "108",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "112",
                    "text": "If yes what concerns does the dentist have about your teeth?",
                    "type": "text",
                    "enableWhen": [
                        {
                            "question": "111",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "113",
                    "text": "Have you had any major work done to your teeth?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "108",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "114",
                    "text": "If yes what major work has been done to your teeth?",
                    "type": "text",
                    "enableWhen": [
                        {
                            "question": "113",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "115",
                    "text": "Do you brush/floss your teeth regularly?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "116",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Dental abnormalities"
                        },
                        {
                            "id": "2",
                            "valueString": "Enamel dysplasia"
                        },
                        {
                            "id": "3",
                            "valueString": "Root thinning/shortening"
                        },
                        {
                            "id": "4",
                            "valueString": "Tooth/root agenesis"
                        },
                        {
                            "id": "5",
                            "valueString": "Microdontia"
                        },
                        {
                            "id": "6",
                            "valueString": "Periodontal disease"
                        },
                        {
                            "id": "7",
                            "valueString": "Tooth decay"
                        },
                        {
                            "id": "8",
                            "valueString": "Malocclusion"
                        },
                        {
                            "id": "9",
                            "valueString": "Xerostomia (salivary gland dysfunction)"
                        },
                        {
                            "id": "10",
                            "valueString": "Osteoradionecrosis"
                        },
                        {
                            "id": "11",
                            "valueString": "Temporomandibular joint dysfunction"
                        },
                        {
                            "id": "12",
                            "valueString": "Other"
                        },
                        {
                            "id": "13",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "14",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "L",
            "text": "Late Effects: Endocrine/Metabolic",
            "type": "group",
            "item": [
                {
                    "linkId": "119",
                    "text": "Height (cm)",
                    "type": "integer"
                },
                {
                    "linkId": "120",
                    "text": "Weight (kg)",
                    "type": "integer"
                },
                {
                    "linkId": "121",
                    "text": "Waist circumference (cm)",
                    "type": "integer"
                },
                {
                    "linkId": "122",
                    "text": "Body Mass Index",
                    "type": "integer"
                },
                {
                    "linkId": "123",
                    "text": "Do you have diabetes?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "No"
                        },
                        {
                            "id": "2",
                            "valueString": "Yes, Type 1"
                        },
                        {
                            "id": "3",
                            "valueString": "Yes, Type 2"
                        },
                        {
                            "id": "4",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "124",
                    "text": "How old were you when you were diagnosed?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "123",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "125",
                    "text": "Are you on medication?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "123",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "126",
                    "text": "Does anyone else in your family have diabetes?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "123",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "127",
                    "text": "Does anyone else in your family have diabetes?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "123",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "128",
                    "text": "Have you ever had any problems with your thyroid?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Hypothyroidism"
                        },
                        {
                            "id": "2",
                            "valueString": "Primary hypothyroidism (thyroid gland failure)"
                        },
                        {
                            "id": "3",
                            "valueString": "Secondary (central) hypothyroidism (TR/TSH deficiency)"
                        },
                        {
                            "id": "4",
                            "valueString": "Hyperthyroidism"
                        },
                        {
                            "id": "5",
                            "valueString": "Thyroid nodule"
                        },
                        {
                            "id": "6",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "7",
                            "valueString": "Don't Remember"
                        }
                    ]
                },
                {
                    "linkId": "129",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Overweight (Age 2-20 yrs: BMI for age >85 - <95%ile; Age >20 yrs: BMI 25 to 29.9)"
                        },
                        {
                            "id": "2",
                            "valueString": "Obesity (Age 2-20 yrs: BMI for age >95%ile; Age >20 yrs, BMI >30)"
                        },
                        {
                            "id": "3",
                            "valueString": "Underweight (FTT)"
                        },
                        {
                            "id": "4",
                            "valueString": "Insulin resistance"
                        },
                        {
                            "id": "5",
                            "valueString": "Metabolic syndrome"
                        },
                        {
                            "id": "6",
                            "valueString": "Precocious puberty"
                        },
                        {
                            "id": "7",
                            "valueString": "Gonadal dysfunction/failure"
                        },
                        {
                            "id": "8",
                            "valueString": "Gonadotropin deficiency (LH/FSH deficiency) [central gonadal failure]"
                        },
                        {
                            "id": "9",
                            "valueString": "Gonadal dysfunction – testicular"
                        },
                        {
                            "id": "10",
                            "valueString": "Gonadal dysfunction – ovarian"
                        },
                        {
                            "id": "11",
                            "valueString": "Impaired glucose tolerance"
                        },
                        {
                            "id": "12",
                            "valueString": "Gestational"
                        },
                        {
                            "id": "13",
                            "valueString": "Dyslipidemia"
                        },
                        {
                            "id": "14",
                            "valueString": "Adrenal insufficiency"
                        },
                        {
                            "id": "15",
                            "valueString": "Primary adrenal insufficiency (adrenal gland failure)"
                        },
                        {
                            "id": "16",
                            "valueString": "Secondary (central) adrenal insufficiency (ACTH deficiency)"
                        },
                        {
                            "id": "17",
                            "valueString": "Hyperprolactinemia"
                        },
                        {
                            "id": "18",
                            "valueString": "Growth deceleration"
                        },
                        {
                            "id": "19",
                            "valueString": "Growth hormone deficiency"
                        },
                        {
                            "id": "20",
                            "valueString": "Short stature (<5th percentile)"
                        },
                        {
                            "id": "21",
                            "valueString": "Other"
                        },
                        {
                            "id": "22",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "23",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "M",
            "text": "Late Effects: Urinary",
            "type": "group",
            "item": [
                {
                    "linkId": "132",
                    "text": "Do you have any problems urinating?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "133",
                    "text": "Have you ever been told there was a problem with your kidney?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "134",
                    "text": "Have you ever been told that there is a problem with your bladder?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "135",
                    "text": "Do you experience urinary urgency?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "136",
                    "text": "Do you suffer from UTIs or cystitis regularly?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "137",
                    "text": "Have you received treatment for them?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "136",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "138",
                    "text": "Do you have blood in your urine?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "139",
                    "text": "Any problems with incontinence (leakage)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "140",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Hydronephrosis"
                        },
                        {
                            "id": "2",
                            "valueString": "Hypertension"
                        },
                        {
                            "id": "3",
                            "valueString": "Renal insufficiency"
                        },
                        {
                            "id": "4",
                            "valueString": "Renal glomerular disorder"
                        },
                        {
                            "id": "5",
                            "valueString": "Hyperfiltration"
                        },
                        {
                            "id": "6",
                            "valueString": "Renal tubular disorder"
                        },
                        {
                            "id": "7",
                            "valueString": "Hypophosphatemic rickets"
                        },
                        {
                            "id": "8",
                            "valueString": "Renal Fanconi syndrome"
                        },
                        {
                            "id": "9",
                            "valueString": "Renal tubular acidosis"
                        },
                        {
                            "id": "10",
                            "valueString": "Vesicoureteral reflux"
                        },
                        {
                            "id": "11",
                            "valueString": "Bladder fibrosis"
                        },
                        {
                            "id": "12",
                            "valueString": "Urinary incontinence"
                        },
                        {
                            "id": "13",
                            "valueString": "Reservoir calculi"
                        },
                        {
                            "id": "14",
                            "valueString": "Dysfunctional voiding"
                        },
                        {
                            "id": "15",
                            "valueString": "Hemorrhagic cystitis"
                        },
                        {
                            "id": "16",
                            "valueString": "Proteinuria"
                        },
                        {
                            "id": "17",
                            "valueString": "Chronic UTI"
                        },
                        {
                            "id": "18",
                            "valueString": "Asymptomatic bacteriuria"
                        },
                        {
                            "id": "19",
                            "valueString": "Neobladder perforation"
                        },
                        {
                            "id": "20",
                            "valueString": "Urinary tract obstruction (due to retroperitoneal fibrosis)"
                        },
                        {
                            "id": "21",
                            "valueString": "Other"
                        },
                        {
                            "id": "22",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "23",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "N",
            "text": "Late Effects: Reproductive (Female)",
            "type": "group",
            "item": [
                {
                    "linkId": "143",
                    "text": "N/A",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "144",
                    "text": "Do you recall ever having a discussion about fertility preservation?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "145",
                    "text": "Did you store eggs?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "146",
                    "text": "Do you have a regular period?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "147",
                    "text": "How old were you when you got your first period?",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ]
                },
                {
                    "linkId": "148",
                    "text": "How frequently? How long does it last?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ]
                },
                {
                    "linkId": "149",
                    "text": "Do you have any pain associated with your period?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ]
                },
                {
                    "linkId": "150",
                    "text": "Do you take regular pain relief for this problem?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "151",
                    "text": "If yes what type of pain relief?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "150",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "152",
                    "text": "Do you take oral contraception/the pill?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "153",
                    "text": "Do you have any children?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "154",
                    "text": "How many children do you have?",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "153",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "155",
                    "text": "Did you have any trouble falling pregnant?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "153",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "156",
                    "text": "Have you ever been told by a GP/oncologist or nurse that you might have problems with your fertility/having children?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "157",
                    "text": "Can you remember what you were told?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "156",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "158",
                    "text": "Do you have any concerns about having children in the future?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "159",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "143",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Breast tissue hypoplasia"
                        },
                        {
                            "id": "2",
                            "valueString": "Uterine vascular insufficiency"
                        },
                        {
                            "id": "3",
                            "valueString": "Adverse pregnancy outcome"
                        },
                        {
                            "id": "4",
                            "valueString": "Pregnancy complications"
                        },
                        {
                            "id": "5",
                            "valueString": "Delivery complications"
                        },
                        {
                            "id": "6",
                            "valueString": "Fetal malposition"
                        },
                        {
                            "id": "7",
                            "valueString": "Low birthweight infant"
                        },
                        {
                            "id": "8",
                            "valueString": "Spontaneous abortion"
                        },
                        {
                            "id": "9",
                            "valueString": "Premature labor"
                        },
                        {
                            "id": "10",
                            "valueString": "Neonatal death"
                        },
                        {
                            "id": "11",
                            "valueString": "Gonadal dysfunction - ovarian"
                        },
                        {
                            "id": "12",
                            "valueString": "Primary ovarian failure"
                        },
                        {
                            "id": "13",
                            "valueString": "Delayed/arrested puberty"
                        },
                        {
                            "id": "14",
                            "valueString": "Premature menopause"
                        },
                        {
                            "id": "15",
                            "valueString": "Infertility"
                        },
                        {
                            "id": "16",
                            "valueString": "Inability to conceive (despite normal ovarian function)"
                        },
                        {
                            "id": "17",
                            "valueString": "Dyspareunia"
                        },
                        {
                            "id": "18",
                            "valueString": "Symptomatic ovarian cysts"
                        },
                        {
                            "id": "19",
                            "valueString": "Pelvic adhesions"
                        },
                        {
                            "id": "20",
                            "valueString": "Psychosexual dysfunction"
                        },
                        {
                            "id": "21",
                            "valueString": "Vaginal stenosis/fibrosi"
                        },
                        {
                            "id": "22",
                            "valueString": "Other"
                        },
                        {
                            "id": "23",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "24",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "O",
            "text": "Late Effects: Reproductive (Male)",
            "type": "group",
            "item": [
                {
                    "linkId": "162",
                    "text": "N/A",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "163",
                    "text": "Do you recall ever having a discussion about fertility preservation?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "162",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "164",
                    "text": "Did you store sperm?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "162",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "165",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "162",
                            "answerCoding": {
                                "display": "No"
                            }
                        }
                    ],
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Gonadal dysfunction - testicular (Germ cell failure, Azoospermia, Oligospermia, Infertility)"
                        },
                        {
                            "id": "2",
                            "valueString": "Leydig cell failure (Hypodonadism testosterone deficiency, delayed/arrested puberty)"
                        },
                        {
                            "id": "3",
                            "valueString": "Psychosexual dysfunction - male (erectile dysfunction, anejunction, retrograd ejaculation, Hydrocele)"
                        },
                        {
                            "id": "4",
                            "valueString": "Other"
                        },
                        {
                            "id": "5",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "6",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "P",
            "text": "Late Effects: Cardiovascular",
            "type": "group",
            "item": [
                {
                    "linkId": "168",
                    "text": "Have you ever been diagnosed with any heart problems?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "169",
                    "text": "Did you receive any treatment for this?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "168",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "170",
                    "text": "Have you had an echocardiogram?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "168",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "171",
                    "text": "Do you know what the result was?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "170",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "172",
                    "text": "Have you had any episodes of chest pain?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "168",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "173",
                    "text": "When does it happen?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "172",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "174",
                    "text": "Do you still experience this?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "172",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "175",
                    "text": "Have you ever been told you should see a doctor for your heart because of some of the chemotherapy or radiotherapy you received?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "176",
                    "text": "Have you ever had a blood clot or Deep Venous Thrombosis (DVT)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "177",
                    "text": "Do you have high blood pressure or are you on medication for high blood pressure?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "178",
                    "text": "Does anyone in your family suffer from high blood pressure?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "179",
                    "text": "List family member(s)",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "178",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "180",
                    "text": "Have you ever been told you have an irregular heartbeat?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "181",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Arrhythmia"
                        },
                        {
                            "id": "2",
                            "valueString": "Atherosclerotic heart disease"
                        },
                        {
                            "id": "3",
                            "valueString": "Cardiomyopathy"
                        },
                        {
                            "id": "4",
                            "valueString": "Congestive heart failure"
                        },
                        {
                            "id": "5",
                            "valueString": "Myocardial infarction"
                        },
                        {
                            "id": "6",
                            "valueString": "Pericardial fibrosis"
                        },
                        {
                            "id": "7",
                            "valueString": "Pericarditis"
                        },
                        {
                            "id": "8",
                            "valueString": "Subclinical left ventricular dysfunction"
                        },
                        {
                            "id": "9",
                            "valueString": "Displayvular disease"
                        },
                        {
                            "id": "10",
                            "valueString": "Carotid artery disease"
                        },
                        {
                            "id": "11",
                            "valueString": "Subclavian artery disease"
                        },
                        {
                            "id": "12",
                            "valueString": "Vasospastic attacks (Raynaud’s phenomenon)"
                        },
                        {
                            "id": "13",
                            "valueString": "Other"
                        },
                        {
                            "id": "14",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "15",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "Q",
            "text": "Late Effects: Pulmonary",
            "type": "group",
            "item": [
                {
                    "linkId": "184",
                    "text": "Have you had any problems with your breathing/lungs since completing treatment?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "185",
                    "text": "Shortness of breath?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "186",
                    "text": "Have you been to the GP about this?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "185",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "187",
                    "text": "What was the outcome?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "186",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "188",
                    "text": "Poor exercise tolerance?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "189",
                    "text": "Have you been to the GP about this?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "188",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "190",
                    "text": "What was the outcome?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "189",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "191",
                    "text": "Tightness in your chest?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "192",
                    "text": "Have you been to the GP about this?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "191",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "193",
                    "text": "What was the outcome?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "192",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "194",
                    "text": "Do you have asthma?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "195",
                    "text": "Do you regularly get colds or flus?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "196",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Bronchiolitis obliterans"
                        },
                        {
                            "id": "2",
                            "valueString": "Interstitial pneumonitis"
                        },
                        {
                            "id": "3",
                            "valueString": "Pulmonary fibrosis"
                        },
                        {
                            "id": "4",
                            "valueString": "Pulmonary dysfunction"
                        },
                        {
                            "id": "5",
                            "valueString": "Acute respiratory distress syndrome (ARDS)"
                        },
                        {
                            "id": "6",
                            "valueString": "Obstructive lung disease"
                        },
                        {
                            "id": "7",
                            "valueString": "Restrictive lung disease"
                        },
                        {
                            "id": "8",
                            "valueString": "Chronic bronchitis"
                        },
                        {
                            "id": "9",
                            "valueString": "Bronchiectasis"
                        },
                        {
                            "id": "10",
                            "valueString": "Other"
                        },
                        {
                            "id": "11",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "12",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "R",
            "text": "Late Effects: Gastrointestinal / Hepatic",
            "type": "group",
            "item": [
                {
                    "linkId": "199",
                    "text": "Do you have any problems with your stomach? (e.g. pain, tenderness, constipation etc.)",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Don't Know"
                        }
                    ]
                },
                {
                    "linkId": "200",
                    "text": "Please select the stomach problems you have experienced",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "199",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "2",
                            "valueString": "Don't Remember"
                        },
                        {
                            "id": "3",
                            "valueString": "Constipation"
                        },
                        {
                            "id": "4",
                            "valueString": "Diarrhea"
                        },
                        {
                            "id": "5",
                            "valueString": "Bleeding from the bowel"
                        },
                        {
                            "id": "6",
                            "valueString": "Pain"
                        },
                        {
                            "id": "7",
                            "valueString": "Tenderness"
                        },
                        {
                            "id": "8",
                            "valueString": "Other"
                        }
                    ]
                },
                {
                    "linkId": "201",
                    "text": "Has any of this been investigated?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "199",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "202",
                    "text": "How often does \"Pain\" happen?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "200",
                            "answerCoding": {
                                "display": "Pain"
                            }
                        }
                    ]
                },
                {
                    "linkId": "203",
                    "text": "How often does \"Tenderness\" happen?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "200",
                            "answerCoding": {
                                "display": "Tenderness"
                            }
                        }
                    ]
                },
                {
                    "linkId": "204",
                    "text": "How often does \"Constipation\" happen?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "200",
                            "answerCoding": {
                                "display": "Constipation"
                            }
                        }
                    ]
                },
                {
                    "linkId": "205",
                    "text": "How often does \"Diarrhea\" happen?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "200",
                            "answerCoding": {
                                "display": "Diarrhea"
                            }
                        }
                    ]
                },
                {
                    "linkId": "206",
                    "text": "How often does \"Bleeding from the bowel\" happen?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "200",
                            "answerCoding": {
                                "display": "Bleeding from the bowel"
                            }
                        }
                    ]
                },
                {
                    "linkId": "207",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Abdominal adhesion"
                        },
                        {
                            "id": "2",
                            "valueString": "Bowel obstruction"
                        },
                        {
                            "id": "3",
                            "valueString": "Bowel strictures"
                        },
                        {
                            "id": "4",
                            "valueString": "Fecal incontinence"
                        },
                        {
                            "id": "5",
                            "valueString": "Cholelithiasis"
                        },
                        {
                            "id": "6",
                            "valueString": "Cholecystitis"
                        },
                        {
                            "id": "7",
                            "valueString": "Chronic enterocolitis"
                        },
                        {
                            "id": "8",
                            "valueString": "Esophageal stricture"
                        },
                        {
                            "id": "9",
                            "valueString": "Fistula"
                        },
                        {
                            "id": "10",
                            "valueString": "Malabsorption"
                        },
                        {
                            "id": "11",
                            "valueString": "Nutritional deficiency"
                        },
                        {
                            "id": "12",
                            "valueString": "Vitamin B12, folate or carotene deficiency"
                        },
                        {
                            "id": "13",
                            "valueString": "Cirrhosis"
                        },
                        {
                            "id": "14",
                            "valueString": "Hepatic fibrosis"
                        },
                        {
                            "id": "15",
                            "valueString": "Hepatic dysfunction"
                        },
                        {
                            "id": "16",
                            "valueString": "Chronic hepatitis (non-infectious)"
                        },
                        {
                            "id": "17",
                            "valueString": "Iron overload"
                        },
                        {
                            "id": "18",
                            "valueString": "Venocclusive disease (VOD) of the liver"
                        },
                        {
                            "id": "19",
                            "valueString": "Other"
                        },
                        {
                            "id": "20",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "21",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "S",
            "text": "Late Effects: Musculoskeletal",
            "type": "group",
            "item": [
                {
                    "linkId": "210",
                    "text": "Do you have any problems with your joints or muscles?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "211",
                    "text": "Do you have any muscle or joint pain?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "212",
                    "text": "Do you think there is any part of your body that hasn’t grown as quickly as the rest?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "213",
                    "text": "Do you have any underdeveloped limbs?",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "212",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "214",
                    "text": "Do you have any curvature of the spine?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "215",
                    "text": "Have you ever had any broken bones or fractures?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "216",
                    "text": "If yes please specify if it was broken or fractured?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "215",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "217",
                    "text": "How did that happen?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "215",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "218",
                    "text": "Do you have any ongoing problems?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "215",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "219",
                    "text": "Did you have surgery or plaster?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "215",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "220",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Scoliosis"
                        },
                        {
                            "id": "2",
                            "valueString": "Reduced/uneven growth"
                        },
                        {
                            "id": "3",
                            "valueString": "Osteonecrosis (avascular necrosis – AVN)"
                        },
                        {
                            "id": "4",
                            "valueString": "Amputation"
                        },
                        {
                            "id": "5",
                            "valueString": "Craniofacial abnormalities"
                        },
                        {
                            "id": "6",
                            "valueString": "Impaired cosmesis"
                        },
                        {
                            "id": "7",
                            "valueString": "Contractures"
                        },
                        {
                            "id": "8",
                            "valueString": "Functional and activity limitation"
                        },
                        {
                            "id": "9",
                            "valueString": "Hypoplasia"
                        },
                        {
                            "id": "10",
                            "valueString": "Kyphosis"
                        },
                        {
                            "id": "11",
                            "valueString": "Limb length discrepancy"
                        },
                        {
                            "id": "12",
                            "valueString": "Limb salvage"
                        },
                        {
                            "id": "13",
                            "valueString": "Phantom pain"
                        },
                        {
                            "id": "14",
                            "valueString": "Prosthesis, malfunction (poor fit, loosening, non-union, fracture)"
                        },
                        {
                            "id": "15",
                            "valueString": "Prosthesis, revision required due to growth"
                        },
                        {
                            "id": "16",
                            "valueString": "Reduced bone mineral density"
                        },
                        {
                            "id": "17",
                            "valueString": "Residual limb integrity problems"
                        },
                        {
                            "id": "18",
                            "valueString": "Increased energy expenditure (related to amputation/limb salvage)"
                        },
                        {
                            "id": "19",
                            "valueString": "Fibrosis (musculoskeletal)"
                        },
                        {
                            "id": "20",
                            "valueString": "Short stature"
                        },
                        {
                            "id": "21",
                            "valueString": "Shortened trunk height"
                        },
                        {
                            "id": "22",
                            "valueString": "Other"
                        },
                        {
                            "id": "23",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "24",
                            "valueString": "Don't Remember"
                        }
                    ]
                },
                {
                    "linkId": "221",
                    "text": "Please specify site of Osteonecrosis (avascular necrosis – AVN)",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "220",
                            "answerCoding": {
                                "display": "Osteonecrosis (avascular necrosis – AVN)"
                            }
                        }
                    ]
                },
                {
                    "linkId": "222",
                    "text": "Please specify type and site of Amputation",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "220",
                            "answerCoding": {
                                "display": "Amputation"
                            }
                        }
                    ]
                },
                {
                    "linkId": "223",
                    "text": "Please specify type of Functional and activity limitation",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "220",
                            "answerCoding": {
                                "display": "Functional and activity limitation"
                            }
                        }
                    ]
                },
                {
                    "linkId": "224",
                    "text": "Please specify site of Hypoplasia",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "220",
                            "answerCoding": {
                                "display": "Hypoplasia"
                            }
                        }
                    ]
                },
                {
                    "linkId": "225",
                    "text": "Please specify type and site of Limb salvage",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "220",
                            "answerCoding": {
                                "display": "Limb salvage"
                            }
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "T",
            "text": "Late Effects: Brain and nervous system",
            "type": "group",
            "item": [
                {
                    "linkId": "228",
                    "text": "Hydrocephalus? (obstruction to flow of cerebrospinal fluid)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "229",
                    "text": "Please give an age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "228",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                },
                {
                    "linkId": "230",
                    "text": "Did you require surgery?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "228",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "231",
                    "text": "Was a third ventriculostomy performed?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "228",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "232",
                    "text": "Was a Shunt performed?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "228",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "233",
                    "text": "Do you still have the shunt?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "232",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "234",
                    "text": "A bleed into the brain/stroke?(Intracranial haemorrhage/cerebrovascular accident)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "235",
                    "text": "Was it confirmed on a brain scan?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "234",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "236",
                    "text": "Did it require surgical intervention?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "234",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "237",
                    "text": "Cerebral palsy?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "238",
                    "text": "Please give an age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "237",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ],
                },
                {
                    "linkId": "239",
                    "text": "Paralysis or weakness of any kind?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "240",
                    "text": "Weakness of the muscles of the eyes?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "239",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "241",
                    "text": "Weakness of the muscles of the face?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "239",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "242",
                    "text": "Weakness or inability to move your arm(s)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "239",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "243",
                    "text": "Weakness or inability to move your leg(s)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "239",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "244",
                    "text": "Weakness of one side of the body (hemiplegia)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "239",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "245",
                    "text": "Please give the age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "244",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "246",
                    "text": "What treatment have you had for this?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "244",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "247",
                    "text": "Learning difficulties?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "248",
                    "text": "Please describe the learning difficulties",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "247",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "249",
                    "text": "Please give age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "247",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "250",
                    "text": "Have you ever been tested for learning/developmental problems? By whom?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "247",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "251",
                    "text": "Have you had neuropsychological testing?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "247",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "252",
                    "text": "Who performed the testing? How many times have you been tested?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "251",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "253",
                    "text": "What did the testing show? What recommendations were provided to the school?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "251",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "254",
                    "text": "Have you received tutoring at/after school?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "247",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "255",
                    "text": "Have you been granted special provisions when writing examinations?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "247",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "256",
                    "text": "Have you ever been told or do you believe that you may have a:",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Learning disorder/disability (math, reading, other_____________)"
                        },
                        {
                            "id": "2",
                            "valueString": "Neurocognitive deficit, specify:"
                        },
                        {
                            "id": "3",
                            "valueString": "Diminished IQ"
                        },
                        {
                            "id": "4",
                            "valueString": "Issues with Executive function (planning/organization)"
                        },
                        {
                            "id": "5",
                            "valueString": "Issues with Sustained attention"
                        },
                        {
                            "id": "6",
                            "valueString": "Memory issues"
                        },
                        {
                            "id": "7",
                            "valueString": "Processing speed"
                        },
                        {
                            "id": "8",
                            "valueString": "Visual-motor integration"
                        },
                        {
                            "id": "9",
                            "valueString": "Fine motor dexterity"
                        },
                        {
                            "id": "10",
                            "valueString": "Language difficulties"
                        }
                    ]
                },
                {
                    "linkId": "257",
                    "text": "Have you experienced Epilepsy / Repeated seizures, fits, convulsions, or blackouts?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                        ,
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "258",
                    "text": "Please give age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "257",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "259",
                    "text": "Was it confirmed on EEG (Electro-encephalography)?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "257",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "260",
                    "text": "Are you currently using medication for this condition?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "257",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "261",
                    "text": "Please list the medication",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "260",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "262",
                    "text": "Have you experienced Migraines, cluster headaches or other frequent headaches?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "263",
                    "text": "Please give age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "262",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "264",
                    "text": "Have you had tests to look for a cause?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "262",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "265",
                    "text": "Are you currently using medication for this condition?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "262",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "266",
                    "text": "Please list the medication",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "265",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "267",
                    "text": "Problems with balance, equilibrium or ability to reach for, or manipulate, objects? (ataxia)",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "268",
                    "text": "Please give age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "267",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "269",
                    "text": "Please describe",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "267",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "270",
                    "text": "Tremors or problems with movements?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "271",
                    "text": "Please give age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "270",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "272",
                    "text": "Please describe",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "270",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "273",
                    "text": "Decreased sense of touch or feeling in your hands, fingers, arms or legs?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "274",
                    "text": "Please give age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "273",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "275",
                    "text": "Have you ever noticed any sensations of pins and needles or tingling in your fingers and toes?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "273",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "276",
                    "text": "Please describe",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "275",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "277",
                    "text": "What treatment have you had for this?",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "275",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "278",
                    "text": "Do you ever have any problems doing up buttons or using a pencil or pen?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "273",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "279",
                    "text": "Please describe",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "278",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "280",
                    "text": "Problems chewing or swallowing solids or liquids?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "281",
                    "text": "Do you need to drink water to help you swallow?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ],
                    "enableWhen": [
                        {
                            "question": "280",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "282",
                    "text": "Please give age when it started (in years)",
                    "type": "integer",
                    "enableWhen": [
                        {
                            "question": "280",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                },
                {
                    "linkId": "283",
                    "text": "Any other brain or nervous system problems?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        },
                        {
                            "id": "3",
                            "valueString": "Unsure"
                        }
                    ]
                },
                {
                    "linkId": "284",
                    "text": "Please describe",
                    "type": "string",
                    "enableWhen": [
                        {
                            "question": "283",
                            "answerCoding": {
                                "display": "Yes"
                            }
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "U",
            "text": "Late Effects: Dermatologic",
            "type": "group",
            "item": [
                {
                    "linkId": "285",
                    "text": "Have you had any problems with your skin?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "286",
                    "text": "Do you have many freckles or moles?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "287",
                    "text": "Do your nails grow?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "288",
                    "text": "Do you have noticeably thin hair?",
                    "type": "choice",
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Yes"
                        },
                        {
                            "id": "2",
                            "valueString": "No"
                        }
                    ]
                },
                {
                    "linkId": "289",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Alopecia (permanent)"
                        },
                        {
                            "id": "2",
                            "valueString": "Dysplastic nevi"
                        },
                        {
                            "id": "3",
                            "valueString": "Altered skin pigmentation"
                        },
                        {
                            "id": "4",
                            "valueString": "Skin fibrosis"
                        },
                        {
                            "id": "5",
                            "valueString": "Nail dysplasia"
                        },
                        {
                            "id": "6",
                            "valueString": "Scleroderma"
                        },
                        {
                            "id": "7",
                            "valueString": "Telangiectasia"
                        },
                        {
                            "id": "8",
                            "valueString": "Other"
                        },
                        {
                            "id": "9",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "10",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "V",
            "text": "Late Effects: Immune",
            "type": "group",
            "item": [
                {
                    "linkId": "290",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Asplenia"
                        },
                        {
                            "id": "2",
                            "valueString": "Chronic sinusitis"
                        },
                        {
                            "id": "3",
                            "valueString": "Chronic graft versus host disease (GVHD)"
                        },
                        {
                            "id": "4",
                            "valueString": "Chronic Hepatitis B"
                        },
                        {
                            "id": "5",
                            "valueString": "Chronic Hepatitis C"
                        },
                        {
                            "id": "6",
                            "valueString": "Chronic infection"
                        },
                        {
                            "id": "7",
                            "valueString": "Human immunodeficiency virus (HIV) infection"
                        },
                        {
                            "id": "8",
                            "valueString": "Hypogammablobulinemia"
                        },
                        {
                            "id": "9",
                            "valueString": "Secretory IgA deficiency"
                        },
                        {
                            "id": "10",
                            "valueString": "Other"
                        },
                        {
                            "id": "11",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "12",
                            "valueString": "Don't Remember"
                        }
                    ]
                },
                {
                    "linkId": "291",
                    "text": "Please specify type of asplenia",
                    "type": "choice",
                    "enableWhen": [
                        {
                            "question": "290",
                            "answerCoding": {
                                "display": "Asplenia"
                            }
                        }
                    ],
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Functional asplenia"
                        },
                        {
                            "id": "2",
                            "valueString": "Surgical asplenia"
                        },
                        {
                            "id": "3",
                            "valueString": "History of life-threatening infection related to asplenia"
                        }
                    ]
                }
            ]
        },
        {
            "linkId": "W",
            "text": "Late Effects: Pain/Chronic",
            "type": "group",
            "item": [
                {
                    "linkId": "292",
                    "text": "Have you experienced any of the following?",
                    "type": "choice",
                    "repeats": true,
                    "answerOption": [
                        {
                            "id": "1",
                            "valueString": "Musculoskeletal"
                        },
                        {
                            "id": "2",
                            "valueString": "Neuropathic"
                        },
                        {
                            "id": "3",
                            "valueString": "Other"
                        },
                        {
                            "id": "4",
                            "valueString": "Not applicable"
                        },
                        {
                            "id": "5",
                            "valueString": "Don't Remember"
                        }
                    ]
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/data.js